import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// eslint-disable-next-line no-unused-vars
import { get,post } from "../api/http";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: null,
        info: "Info",
        // 微信授权返回
        code: null,
        // 微信openId
        openId: null,
        // 体检时段
        physical: [],
        // 胃肠道时段
        colonoscopy: [],
        // 医院
        hospital: [],
        // 与本人关系
        rela: [],
        // 报告类型字典
        report_type: [],
        // 微信支付结果
        wxapy: null,
        // 本人手机号
        phoneNo: null,
        // 报告类型
        type: [],
        // 随访预约医院
        appointHospital: [],
        // 随访预约时段
        appointFolllow: [],
        // 分享router
        Routers: {},
        // 分享userid
        UserId: null,
        // 附加项项目类型
        itemPlusType: [],
        // 订单状态
        orderState: [],
        // 教育程度 - 试剂盒
        educationLevelList: [],
        // 婚姻状况 - 试剂盒
        maritalStatusList: [],
        // 医保类型 - 试剂盒
        medicalInsuranceTypeList: [],
        // 职业 - 试剂盒
        occupation: []
    },
    mutations: {
        setOccupation(state,data) {
            state.occupation= data;
        },
        setEducationLevelList(state,data) {
            state.educationLevelList= data;
        },
        setMaritalStatusList(state,data) {
            state.maritalStatusList= data;
        },
        setMedicalInsuranceTypeList(state,data) {
            state.medicalInsuranceTypeList= data;
        },
        setOrderState(state,data) {
            state.orderState= data;
        },
        setOpenId(state,data) {
            state.openId= data;
        },
        setItemPlusType(state,data) {
            state.itemPlusType= data;
        },
        setUserId(state,data) {
            state.UserId= data;
        },
        setRouters(state,data) {
            state.Routers= data;
        },
        setAppointFolllow(state,data) {
            state.appointFolllow= data;
        },
        setAppointHospital(state,data) {
            state.appointHospital= data;
        },
        setType(state,data) {
            state.type= data;
        },
        setPhoneNo(state,data) {
            state.phoneNo= data;
        },
        setWxapy(state,data) {
            state.wxapy= data;
        },
        setToken(state,data) {
            state.token= data;
        },
        setInfo(state,data) {
            state.info= data;
        },
        setPhysical(state,data) {
            state.physical= data;
        },
        setColonoscopy(state,data) {
            state.colonoscopy= data;
        },
        setHospital(state,data) {
            state.hospital= data;
        },
        setRela(state,data) {
            state.rela= data;
        },
        setCode(state,data) {
            state.code= data;
        },
        setReportType(state,data) {
            state.report_type= data;
        }
    },
    actions: {
        setOccupation(context,data) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/reagent/occupation",{type: data})
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setOccupation",res);
                })
        },
        setEducationLevelList(context,data) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/reagent/education",{type: data})
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setEducationLevelList",res);
                })
        },
        setMaritalStatusList(context,data) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/reagent/marital",{type: data})
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setMaritalStatusList",res);
                })
        },
        setMedicalInsuranceTypeList(context,data) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/reagent/insuranceType",{type: data})
                    .then(res=> {
                        console.log(res)
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setMedicalInsuranceTypeList",res);
                })
        },
        setOrderState(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/order/status")
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setOrderState",res);
                })
        },
        setItemPlusType(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/dict/itemPlusType")
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setItemPlusType",res);
                })
        },
        setAppointFolllow(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/dict/follow-appoint")
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setAppointFolllow",res);
                })
        },
        setAppointHospital(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/dict/appointHospital")
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setAppointHospital",res);
                })
        },
        setType(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/dict/report-type")
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setType",res);
                })
        },
        setPhysical(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/appointmentTime","physical_examination",true)
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setPhysical",res);
                })
        },
        setColonoscopy(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/appointmentTime","colonoscopy_examination",true)
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setColonoscopy",res);
                })
        },
        setHospital(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve,reject) => {
                get("base/appointmentHospital")
                    .then(res=> {
                        resolve(res.data)
                    })
            })
                .then(res => {
                    context.commit("setHospital",res);
                })
        },
        setRela(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise( (resolve, reject)=> {
                get("base/dict/relationship")
                    .then(res => {
                        resolve(res.data);
                    })
            })
                .then(res=> {
                    context.commit("setRela",res);
                })
        },
        setReportType(context) {
            // eslint-disable-next-line no-unused-vars
            return new Promise( (resolve, reject)=> {
                get("base/dict/report-type")
                    .then(res => {
                        resolve(res.data);
                    })
            })
                .then(res=> {
                    res.splice(res.length-1,1)
                    context.commit("setReportType",res);
                })
        }
    },
    modules: {},
    plugins: [createPersistedState({
        key: "newOfficial"
    })],
})
